import React from "react";
import { Link } from "react-router-dom";
import { FiHelpCircle, FiMapPin } from "react-icons/fi";
import classNames from "../common/classNames";

const defaultLinks = [
  { label: "Our Story", href: "/about" },
  { label: "Wholesale", href: "/wholesale" },
  { label: "Reviews", href: "/reviews" },
  { label: "Contact", href: "/contact" },
];

const UtilityLink = ({ href, children, ...props }) => {
  if (href?.startsWith("/")) {
    return (
      <Link to={href} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} {...props}>
      {children}
    </a>
  );
};

const UtilityBar = ({ links = defaultLinks, className }) => (
  <div className={classNames("utility-bar", className)}>
    <div className="site-container utility-bar__inner">
      <nav className="utility-bar__nav" aria-label="Helpful links">
        <ul>
          {links.map((link) => (
            <li key={link.href}>
              <UtilityLink href={link.href}>{link.label}</UtilityLink>
            </li>
          ))}
        </ul>
      </nav>
      <nav className="utility-bar__actions" aria-label="Customer tools">
        <UtilityLink href="/track-order">
          <FiMapPin aria-hidden="true" />
          <span>Track order</span>
        </UtilityLink>
        <UtilityLink href="/contact">
          <FiHelpCircle aria-hidden="true" />
          <span>Support</span>
        </UtilityLink>
      </nav>
    </div>
  </div>
);

export default UtilityBar;
